// src/redux/order/order.actions.js
import { OrderActionTypes } from './order.types';
import { 
  firestore, 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  orderBy,
  doc,
  updateDoc
} from '../../firebase/firebase.utils';

// ===== CREATE ORDER IN FIRESTORE =====
export const createOrder = (orderData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: true });
      
      const ordersRef = collection(firestore, 'orders');
      const newOrder = {
        ...orderData,
        orderNumber: `ORD-${Date.now().toString().slice(-8)}`,
        status: 'pending',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      const docRef = await addDoc(ordersRef, newOrder);
      
      dispatch({ 
        type: OrderActionTypes.CREATE_ORDER, 
        payload: { id: docRef.id, ...newOrder }
      });
      
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: false });
      return { success: true, orderId: docRef.id, orderNumber: newOrder.orderNumber };
      
    } catch (error) {
      console.error('Error creating order:', error);
      dispatch({ type: OrderActionTypes.SET_ERROR, payload: error.message });
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: false });
      return { success: false, error: error.message };
    }
  };
};

// ===== FETCH ALL ORDERS =====
export const fetchOrders = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: true });
      
      const ordersRef = collection(firestore, 'orders');
      const q = query(ordersRef, orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      
      const orders = [];
      querySnapshot.forEach((doc) => {
        orders.push({
          id: doc.id,
          ...doc.data()
        });
      });
      
      dispatch({ 
        type: OrderActionTypes.SET_ORDERS, 
        payload: orders 
      });
      
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: false });
      
    } catch (error) {
      console.error('Error fetching orders:', error);
      dispatch({ type: OrderActionTypes.SET_ERROR, payload: error.message });
      dispatch({ type: OrderActionTypes.SET_LOADING, payload: false });
    }
  };
};

// ===== UPDATE ORDER STATUS =====
export const updateOrderStatus = (orderId, status) => {
  return async (dispatch) => {
    try {
      const orderRef = doc(firestore, 'orders', orderId);
      await updateDoc(orderRef, { 
        status: status,
        updatedAt: new Date().toISOString()
      });
      
      dispatch({ 
        type: OrderActionTypes.UPDATE_ORDER, 
        payload: { id: orderId, status }
      });
      
    } catch (error) {
      console.error('Error updating order:', error);
    }
  };
};